import styled from 'styled-components';
import { Text16Regular, Text24Bold } from '../../../components/utils/Text/Text.styles';

export const PageContainer = styled.div`
  max-height: 100dvh;
  height: 100%;
  display: flex;

  @media only screen and (max-width: 768px) {
    max-height: calc(100dvh - 5.6rem);
  }
`;

export const Title = styled(Text24Bold)`
  letter-spacing: -0.408px;
`;

export const Navigator = styled.nav`
  display: flex;
  flex-direction: column;
  min-width: 38rem;
  border-right: 1px solid #f3f4f6;
  background-color: #fff;

  @media screen and (max-width: 1100px) {
    max-width: 55rem;
  }

  @media screen and (max-width: 900px) {
    max-width: 25rem;
    min-width: 25rem;
  }

  @media screen and (max-width: 768px) {
    min-width: unset;
    max-width: unset;
    width: 100%;
    border-right: none;
  }
`;

export const Content = styled.div`
  overflow: scroll;
  width: 100%;
`;

export const NavigationContainer = styled.div`
  height: calc(100% - 7.8rem);
  display: flex;
  flex-direction: column;
`;

export const ListContainer = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.div`
  padding: 1.6rem 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f3f4f6;
  gap: 0.4rem;
  cursor: pointer;
  background: ${({ $selected }) => ($selected ? '#EEF5FD' : 'transparent')};
`;

export const ListItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const ListItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const MediaCountRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const MediaCountText = styled(Text16Regular)`
  color: #6c737f;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.4rem 1.6rem 1.2rem 1.6rem;
  border-bottom: 1px solid #f3f4f6;
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const ArrowButton = styled.button`
  outline: none;
  background-color: transparent;
  height: 2.4rem;
`;

export const AddBundle = styled.button`
  border-radius: 12px;
  border: 1px solid #61ade9;
  background: linear-gradient(93deg, #3e9be4 6.75%, #1672ba 93.25%);
  height: 3.2rem;
  width: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    path {
      stroke: #fff;
    }
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 13.7rem);
`;

export const FilterWrapper = styled.div`
  margin-top: 1rem;
`;

export const Filter = styled.div`
  background: #f3f4f6;
  height: 3.8rem;
  padding: 0.4rem;
  display: flex;
`;

export const FilterButton = styled.button`
  background: ${({ $selected }) => ($selected ? '#FFF' : 'transparent')};
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #170c2f;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.8rem;
  letter-spacing: -0.5px;
  opacity: ${({ $selected }) => !$selected && '0.5'};
  border-radius: 8px;
  border: ${({ $selected }) => $selected && '1px solid #E5E7EB'};
  box-shadow: ${({ $selected }) => $selected && '4px 5px 2px 0 rgba(0, 0, 0, 0), 2px 3px 2px 0 rgba(0, 0, 0, 0.01)'};
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.4rem 1.6rem;
`;

export const SyncButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  border: 1px solid #e5e7eb;
  background-color: transparent;
  border-radius: 8px;
  padding: 0.4rem 1rem;
  font-size: 1.5rem;
  font-weight: 500;
  opacity: ${({ disabled }) => disabled && '0.5'};
  pointer-events: ${({ disabled }) => disabled && 'none'};
`;
